import { action } from "../../../utils/actions";

export const GET_GLOBAL_COORDINATORS = action("GET_GLOBAL_COORDINATORS");
export const ADD_GLOBAL_COORDINATOR = action("ADD_GLOBAL_COORDINATOR");
export const CREATE_GLOBAL_COORDINATOR = action("CREATE_GLOBAL_COORDINATOR");
export const EDIT_GLOBAL_COORDINATOR = action("EDIT_GLOBAL_COORDINATOR");
export const OPEN_EDITION_GLOBAL_COORDINATOR = action(
  "OPEN_EDITION_GLOBAL_COORDINATOR",
);
export const REMOVE_GLOBAL_COORDINATOR = action("REMOVE_GLOBAL_COORDINATOR");
